module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAM1BMVEUAAADMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMz////r6+va2tr5+fny8vI1iT64AAAAC3RSTlMAlY8rBvnXvPTU2EnH+r0AAABlSURBVBjTZU9JEoAwCIsgdSnV/v+1Tknx0lwSwjIEAyrFrIiC2Lc6se1RH/XHMRz2cwbQEN39DaGQ4FYfb0MICmfTKLBpvB5kaTQnn7nSO/mC5A2SQPMEHV0eW15fwzH+befF+B93TQhvMaHwLQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_explain.png
// module id = 0LJ9
// module chunks = 9